import { Avatar } from "@mui/material";
import EditIcon from 'assets/icons/svg/Edit/index';
import { ReactComponent as DeleteIcon } from "assets/icons/Trush.svg";
import { HintField, Text } from "components";
import Button from "components/button/Button";
import { useMobileView } from "hook/mobileView/useMobileView";
import React, { useState } from "react";
const MournersList = ({
  drawerDisplay,
  handleClick,
  mourners,
  handleDelete,
  setDisable,
  isEdit,
  mourner,
  disableEditing,
  onEditClick,
  ...props
}) => {
  const [error, setError] = useState("");
  const formik = { ...props };
  const { isMobile } = useMobileView()

  return (
    <div
      className={!drawerDisplay ? "mourners-list" : "drawer-mourner-list px-8"}
    >
      {!drawerDisplay && <Text className="sub-title">Mourners list</Text>}
      <div className="list-contant">
        {mourners?.length > 0 &&
          mourners?.map((mourner, index) => {
            return (
              <div className="member-card" key={index} style={{ position: 'relative', width: '100%' }}>
                <div className="card-content" style={{ paddingRight: '70px' }}>
                  <div className="member-container">
                    <div className="member-img">
                      <Avatar
                        className="avatar"
                        style={{
                          background:
                            mourner?.profile_img && mourner?.profile_img !== ""
                              ? "transparent"
                              : mourner?.member_id || mourner?._id
                              ? "#4CAF50"
                              : "#8E8E8E",
                          height: "40px",
                          borderRadius: "6px",
                          width: "40px",
                        }}
                        alt={`${mourner.first_name}`}
                        src={
                          mourner?.profile_img && mourner?.profile_img !== ""
                            ? mourner?.profile_img
                            : "/example.jpg"
                        }
                      ></Avatar>
                    </div>
                    <div className="member-name">
                      {mourner?.member_id || mourner?._id
                        ? `${mourner?.first_name} ${mourner?.last_name}`
                        : mourner?.email}
                      <div className="member-t">{`${mourner?.relation?.name ??
                        mourner?.relation}`}</div>
                    </div>
                  </div>
                </div>
                <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {drawerDisplay && (
                    <div
                      className="cursor-pointer"
                      role="button"
                      aria-label="Edit mourner"
                      tabIndex={0}
                      onClick={() => { onEditClick(mourner); }}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onEditClick(mourner); }}
                    >
                      <EditIcon style={{ verticalAlign: "bottom" }} />
                    </div>
                  )}
                  <div
                    className="cursor-pointer"
                    role="button"
                    aria-label="Delete mourner"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        if(disableEditing) return;
                        if (setDisable) setDisable(false);
                        handleDelete(index);
                      }
                    }}
                  >
                    <DeleteIcon
                      onClick={() => {
                        if(disableEditing) return;
                        if (setDisable) setDisable(false);
                        handleDelete(index);
                      }}
                      width={24}
                      height={24}
                    />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {!drawerDisplay && (
        <div className="py-10" style={{ marginLeft: 20 }}>
          <div aria-live="polite" aria-atomic="true">
            {!mourners?.length > 0 ? <HintField error={error} /> : null}
          </div>
          <Button
            variant="primary"
            size="md"
            style= {{minWidth: isMobile? "150px":"320px"}}
            onClick={() => {
              if(disableEditing) return;
              if (mourners?.length > 0 || formik?.values?.doesnt_have_mourner)
                handleClick();
              else setError("Add 1 mourner at least to continue");
            }}
            disabled={disableEditing}
          >
            Continue
          </Button>
        </div>
      )}
    </div>
  );
};

export default MournersList;
